/**
 * @generated SignedSource<<a511f43700f7f7a64fe64e0c2a9f3b9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TestScope$data = {
  readonly testOccurrences: {
    readonly testCounters: {
      readonly all: number | null | undefined;
      readonly duration: number | null | undefined;
      readonly failed: number | null | undefined;
      readonly ignored: number | null | undefined;
      readonly muted: number | null | undefined;
      readonly success: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"TestScopeName">;
  readonly " $fragmentType": "TestScope";
};
export type TestScope$key = {
  readonly " $data"?: TestScope$data;
  readonly " $fragmentSpreads": FragmentRefs<"TestScope">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TestScope",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TestScopeName"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TestOccurrences",
      "kind": "LinkedField",
      "name": "testOccurrences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TestCounters",
          "kind": "LinkedField",
          "name": "testCounters",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "failed",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "success",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "muted",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "all",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ignored",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "duration",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TestScope",
  "abstractKey": null
};

(node as any).hash = "543bb5dcbbd45231bb3a48502f2758e6";

export default node;
